export const itemsBreadcrumb = (isEdit: boolean) => [
  {
    value: '1',
    label: 'Pacientes',
    link: '/usuario/pacientes',
  },
  {
    value: '2',
    label: isEdit ? 'Visualizar e editar paciente' : 'Adicionar paciente',
    active: true,
  },
]

export enum ModalsRegisterPatient {
  ELIGIBILITY_CHECK = 'ELIGIBILITY_CHECK',
  ELIGIBILITY_CHECK_WELLHUB = 'ELIGIBILITY_CHECK_WELLHUB',
}
